import { Link } from "react-router-dom";

import { COMPANY_NAME } from "@/utils/constants/defaultNames";
import { formatTestId } from "@/utils/formatTestId";

const Footer = () => {
  const footerLinks = [
    { name: "Terms & Conditions", to: "/" },
    { name: "Privacy policy", to: "/" },
    { name: "Cookies", to: "/" },
  ];

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-100" data-testid="footer">
      <div className="py-[13px] px-4 flex items-center justify-between">
        <p className="text-gray-400 text-xs">
          © {currentYear} {COMPANY_NAME}
        </p>
        <ul className="flex items-center gap-x-6" data-testid="footer-links">
          {footerLinks.map(elem => (
            <li key={elem.name}>
              <Link
                to={elem.to}
                target="_blank"
                className="text-gray-400 text-xs"
                data-testid={`footer-link-${formatTestId(elem.name)}`}
              >
                {elem.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
